import ScenarioView from './ScenarioView'

export default ScenarioView
